import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=5f387cf0&scoped=true"
import script from "./CardCheck.vue?vue&type=script&lang=js"
export * from "./CardCheck.vue?vue&type=script&lang=js"
import style0 from "./CardCheck.vue?vue&type=style&index=0&id=5f387cf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f387cf0",
  null
  
)

export default component.exports